'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = useFocused;

var _react = require('react');

function useFocused(_ref) {
  var focused = _ref.focused,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      focusedState = _useState2[0],
      setFocusedState = _useState2[1];

  var handleFocus = (0, _react.useCallback)(function (evt) {
    if (onFocus) onFocus(evt);
    setFocusedState(true);
  }, [onFocus]);

  var handleBlur = (0, _react.useCallback)(function (evt) {
    if (onBlur) onBlur(evt);
    setFocusedState(false);
  }, [onBlur]);

  return {
    focused: focused != null ? focused : focusedState,
    onFocus: focusedState ? onFocus : handleFocus,
    onBlur: focusedState ? handleBlur : onBlur
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/hooks/useFocused.js
// module id = 197
// module chunks = 177